export function generateGA4Timestamp() {
    return (
        // eslint-disable-next-line no-undef
        `${new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false,
            timeZone: 'America/New_York',
        })
            .format(new Date())
            .replace(/,/g, ' ')} ET`
    )
}

export function trackEvent(
    category: string,
    action: string,
    label?: string,
    value?: string,
) {
    const { dataLayer } = window

    if (!dataLayer || !dataLayer.push) {
        return
    }

    const event = {
        event: 'Event',
        action,
        category,
        label,
        value,
    }

    dataLayer.push(event)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function trackGA4Event(name: string, data: any) {
    window.dataLayer = window.dataLayer || []

    const event = {
        event: name,
        time_stamp: generateGA4Timestamp(),
        ...data,
    }

    window.dataLayer.push(event)
}
